import React, { useEffect } from "react";
import "./Reportes.css";
import { Link } from "react-router-dom";

export default function Reportes() {
  useEffect(() => {}, []);

  return (
    <div>
      <div id="project-qr" className="row">
        <div className="">
          <h4 className="page-title">REPORTES</h4>
        </div>
      </div>
      <div id="project-qr" className="row">
        <div className="col-3">
          <div className="center">
            <Link
              rel="stylesheet"
              state={{ Name: "Venta por dia y turno", Mod: "Venta" }}
              to={{ pathname: "/VentasTurno" }}
            >
              <img alt="" className="qr-code" src="/images/Sun.png"></img>
              <div className="center">Ventas por dia y turno</div>
            </Link>
          </div>
        </div>
        <div className="col-3">
          <div className="center">
            <Link
              rel="stylesheet"
              state={{ Name: "Ventas por agente de servicio", Mod: "VentasAS" }}
              to={{ pathname: "/VentasEmpleado" }}
            >
              <img alt="" className="qr-code" src="/images/Seller.png"></img>
              <div className="center">Ventas por agente de servicio</div>
            </Link>
          </div>
        </div>
        <div className="col-3">
          <div className="center">
            <Link
              rel="stylesheet"
              state={{
                Name: "Productos mas y menos vendidos",
                Mod: "Productos",
              }}
              to={{ pathname: "/filtros" }}
            >
              <img
                alt=""
                className="qr-code"
                src="/images/Hambuerguer.png"
              ></img>
              <div className="center">Productos mas y menos vendidos</div>
            </Link>
          </div>
        </div>
        <div className="col-3">
          <div className="center">
            <Link
              rel="stylesheet"
              state={{
                Name: "Platillos mas guardados en lista de deseos",
                Mod: "Platillos",
              }}
              to={{ pathname: "/filtros" }}
            >
              <img alt="" className="qr-code" src="/images/Heart.png"></img>
              <div className="center">
                Platillos mas guardados en lista de deseos
              </div>
            </Link>
          </div>
        </div>
        <div className="col-3">
          <div className="center">
            <Link
              rel="stylesheet"
              state={{
                Name: "Utilidades estimadas sobre los productos",
                Mod: "Utilidades",
              }}
              to={{ pathname: "/filtros" }}
            >
              <img alt="" className="qr-code" src="/images/Money.png"></img>
              <div className="center">
                Utilidades estimadas sobre los productos
              </div>
            </Link>
          </div>
        </div>
        <div className="col-3">
          <div className="center">
            <Link
              rel="stylesheet"
              state={{
                Name: "Proyecciones de venta estimados",
                Mod: "Proyecciones",
              }}
              to={{ pathname: "/filtros" }}
            >
              <img alt="" className="qr-code" src="/images/Chart.png"></img>
              <div className="center">Proyecciones de venta estimados</div>
            </Link>
          </div>
        </div>
        <div className="col-3">
          <div className="center">
            <Link
              rel="stylesheet"
              state={{
                Name: "Ventas por area o tipo de servicio",
                Mod: "VentasA",
              }}
              to={{ pathname: "/filtros" }}
            >
              <img alt="" className="qr-code" src="/images/Area.png"></img>
              <div className="center">Ventas por area o tipo de servicio</div>
            </Link>
          </div>
        </div>
        <div className="col-3">
          <div className="center">
            <Link
              rel="stylesheet"
              state={{ Name: "Ventas por mesa", Mod: "VentasM" }}
              to={{ pathname: "/filtros" }}
            >
              <img alt="" className="qr-code" src="/images/Table2.png"></img>
              <div className="center">Ventas por mesa</div>
            </Link>
          </div>
        </div>
        <div className="col-12">
          <div className="center">
            <Link
              rel="stylesheet"
              state={{
                Name: "Analisis de venta de productos con promocion",
                Mod: "AnalisisV",
              }}
              to={{ pathname: "/filtros" }}
            >
              <img
                alt=""
                className="qr-code"
                src="/images/Promotions.png"
              ></img>
              <div className="center">
                Analisis de venta de productos con promocion
              </div>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
